import { Component, OnInit } from '@angular/core';
import { LoadingScreenService } from '../services/loading-screen.service';

@Component({
  standalone: false,
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {

  public loadingService: LoadingScreenService;

  constructor(loadingService: LoadingScreenService) {
    this.loadingService = loadingService
  }

  ngOnInit(): void {
    this.loadingService.stopLoading()
  }

  ngOnDestroy(): void {

  }
}